<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">Selección de grupos</span>
        </v-card-title>
        <v-card-text>
          <v-layout class="gruoup-selector-modal">
            <v-flex xs12>
              <v-data-table
                ref="dTable"
                v-model="selected.levels"
                :headers="headers"
                :items="items"
                :expand="expand"
                select-all
                item-key="id"
                hide-actions
                :loading="working.loading"
                no-data-text="No hay grupos a entregar por el momento, esto puede deberse a que aún no es hora de salida"
              >
                <v-progress-linear
                  v-slot:progress
                  color="secondary"
                  background-color="primary"
                  indeterminate
                ></v-progress-linear>
                <template v-slot:headers="props">
                <tr>
                  <th>
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      v-bind="checkAll"
                      primary
                      :disabled="loading"
                      color="primary"
                      hide-details
                      @change="selectAll"
                    />
                  </th>
                  <th v-for="header in headers" :key="header.id">
                    {{header.text}}
                  </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr @click="props.expanded = !props.expanded" :id="props.item.id">
                    <td>
                      <v-checkbox color="primary" v-model="props.selected" primary hide-details
                        @change="levelHandler(selected.levels, [props.item.id], $event)"
                      ></v-checkbox>
                    </td>
                    <td>
                      <v-tooltip bottom>
                        <v-btn slot="activator" icon>
                          <v-icon v-if="!props.expanded">add</v-icon>
                          <v-icon v-else>remove</v-icon>
                        </v-btn>
                        <span>Ver grupos</span>
                      </v-tooltip>
                    </td>
                    <td class="text-xs-center" style="width: 100px; max-width: 100px; min-width: 100px;">{{ props.item.typeLevel }}</td>
                    <td class="text-xs-center" style="width: 120px; max-width: 120px; min-width: 120px;">{{ props.item.abbr }}</td>
                    <td class="text-xs-center" style="width: 150px; max-width: 150px; min-width: 150px;">{{ props.item.departureTime }}</td>
                    
                  </tr>
                </template>
                <template v-slot:expand="props">
                  <v-card flat>
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex v-for="gg in props.item.ggs" :key="gg.id" xs12>
                          <v-checkbox
                            color="primary"
                            :label="gg.grade + ' ' + gg.group"
                            v-model="selected.ggs"
                            :value="gg"
                            @change="gradeGroupHandler"
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="working.wUpdate" flat @click="close">Cancelar</v-btn>
          <v-btn
            :disabled="working.wUpdate"
            color="primary darken-1"
            flat
            @click="start($event)"
          >Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <alert
      v-model="toast.alert"
      title="¡Alerta!"
      description="Debes de seleccionar al menos un grupo"
    ></alert>
    <remember
      v-model="toast.remember"
      @click="handleClick"
    ></remember>
  </div>
</template>

<script>
import alert from "../Dialogs/Alert";
import remember from "../Dialogs/RememberGroup/RememberGroup.vue";
export default {
  components: {
    alert,
    remember
  },
  props: ["value", "startFlag", "selectedGG"],
  watch: {
    async value() {
      if (this.value) {
        await this.getLevels();
        await this._setInitialState()
        this.gradeGroupsDictionary = 
        this._groupBy(this.items, (e) => [
          e.id,
          {
            isSelected: false,
            ...e, 
            groupByGroupId: this._groupBy(e.ggs, (el) => [
              el.id, 
              {
                isSelected: false,
                ...el
              }
            ])
          }
        ]);
        this.gradeGroupsDictionaryInitialState = structuredClone(this.gradeGroupsDictionary)
        this._setLevelsAndGradeGroups()
      } else {
        this.working.wUpdate = false;
      }
    },
    selectedGG() {
      // console.log(2, structuredClone(this.selectedGG));
      // this.selected.ggs = this.selectedGG;
      // const selectedGgs = structuredClone(this.selectedGG).map((e)=>({ "id": e.id, "grade": e.grade, "group": e.group, "deleted": this._isNull(e.deleted, false), "levelId": e.levelId, "nStudents": this._isNull(e.nStudents, 0) }))
      // console.log(3, structuredClone((this.items)));
      // console.log(1, structuredClone(selectedGgs));
      // this.selected.ggs = selectedGgs
      // this._setGgs()
      // if (this.selectedGG != null && this.selectedGG.length == 0) {
      //   this.selected.levels = [];
      // }
    },
    "selected.ggs": {
      handler(val, oldVal){
        // const initialCount = 1
        // this.levelsDictionary = {}
        // this.selected.levels = []
        
        // const ggs={}

        // for (const gg of val) {
          // if (this.levelsDictionary[gg.levelId] === undefined) {
          //   this.levelsDictionary[gg.levelId] = { levelId: gg.levelId, count: initialCount, isFullLevelSelected : this.gradeGroupsDictionary[gg.levelId].ggs.length === initialCount  }

          //   if (this.levelsDictionary[gg.levelId].isFullLevelSelected) {
          //     this.selected.levels.push(this.gradeGroupsDictionary[gg.levelId])
          //   }

          //   continue
          // }
          
          // this.levelsDictionary[gg.levelId].count =  ++this.levelsDictionary[gg.levelId].count
          // this.levelsDictionary[gg.levelId].isFullLevelSelected =  this.gradeGroupsDictionary[gg.levelId].ggs.length === this.levelsDictionary[gg.levelId].count

          // -----------

          
        // }
        //   console.log(structuredClone(this.levelsDictionary));
      }
    },
    "selected.levels": {
      handler(value, oldValue) {
        // const selectedGroups = value.map((e)=> e.ggs).flat()
        // this.selected.ggs = selectedGroups
        // if (oldValue.length < value.length) {
        //   for (var lvl in this.selected.levels) {
        //     for (var gg in this.selected.levels[lvl].ggs) {
        //       if (
        //         !this.selected.ggs.includes(this.selected.levels[lvl].ggs[gg])
        //       ) {
        //         this.selected.ggs.push(this.selected.levels[lvl].ggs[gg]);
        //       }
        //     }
        //   }
        // } else {
        //   for (var lvlOld of oldValue) {
        //     if (!value.includes(lvlOld)) {
        //       for (var gg in lvlOld.ggs) {
        //         if (this.selected.ggs.includes(lvlOld.ggs[gg])) {
        //           this.selected.ggs.splice(
        //             this.selected.ggs.indexOf(lvlOld.ggs[gg]),
        //             1
        //           );
        //         }
        //       }
        //     }
        //   }
        // }
      }
    },
    "gradeGroupsDictionary":{
      handler(value, oldValue) {
        this.selected.levels = Object.values(structuredClone(value)).filter((e)=> e.isSelected === true).flat()
      }
    }
  },
  data: () => ({
    checkAll: false,
    selected: {
      levels: [],
      ggs: []
    },
    expand: true,
    items: [],
    headers: [
      {
        text: "Grupos  ",
        value: "groups"
      },
      {
        text: "Nombre",
        value: "name"
      },
      {
        text: "Abreviación",
        value: "abbr"
      },
      {
        text: "Hora de salida",
        value: "departureTime"
      },
    ],
    working: {
      wUpdate: false
    },
    toast: {
      success: false,
      failed: false,
      alert: false,
      remember: false,
    },
    levelsDictionary: {},
    gradeGroupsDictionary: {},
  }),
  methods: {
    gradeGroupHandler(ggs = []){
      this.gradeGroupsDictionary = structuredClone(this.gradeGroupsDictionaryInitialState)
      this.selected.ggs = []
      this.levelsDictionary = {}

      for (const gg of ggs) {
        this.gradeGroupsDictionary[gg.levelId].groupByGroupId[gg.id].isSelected = true
        this.selected.ggs.push(gg)
        this.levelsDictionary[gg.levelId] = gg.levelId

        const allGgSelected = Object.values(this.gradeGroupsDictionary[gg.levelId].groupByGroupId).every(e => e.isSelected === true)

        if (allGgSelected) {
          this.gradeGroupsDictionary[gg.levelId].isSelected = true
        }
      }

      return Object.keys(this.levelsDictionary)

      // -------------
      // this.levelsDictionary = {}
      // const selectedLvls = {}

      // for (const gg of this.selected.ggs) {
      //   if (this.levelsDictionary[gg.levelId] === undefined) {
      //     this.levelsDictionary[gg.levelId] = { levelId: gg.levelId, count: 1, isFullLevelSelected : false  }
      //     this.levelsDictionary[gg.levelId].isFullLevelSelected = this.gradeGroupsDictionary[gg.levelId].ggs.length === 1
      //   }else{
      //     this.levelsDictionary[gg.levelId].count =  this.levelsDictionary[gg.levelId].count + 1
      //     this.levelsDictionary[gg.levelId].isFullLevelSelected =  this.gradeGroupsDictionary[gg.levelId].ggs.length === this.levelsDictionary[gg.levelId].count
      //   }
      
      //   if (this.levelsDictionary[gg.levelId].isFullLevelSelected) {
      //     selectedLvls[gg.levelId] = this.gradeGroupsDictionary[gg.levelId]
      //   }else{
      //     selectedLvls[gg.levelId] = null
      //   }
      // }

      // this.selected.levels = Object.values(selectedLvls).filter((e)=> e !== null)
      // return Object.keys(this.levelsDictionary)
    },
    levelHandler(val= [], itemIds = [], event = false){
      const lvls = structuredClone(val)
      const tempGgsDictionary = {}

      for (const gg of this.selected.ggs) {
        tempGgsDictionary[gg.id] = gg
      }

      const ggsFromLvls = lvls.map((e)=> e.ggs).flat()
      for (const gg of ggsFromLvls) {
        tempGgsDictionary[gg.id] = gg
      }

      let ggs = Object.values(tempGgsDictionary)
      if (event === false) {
        for (const itemId of itemIds) {
          ggs = ggs.filter((e)=> e.levelId !== itemId)
        }
      }

      this.selected.ggs = ggs

      // ----------
      // this.gradeGroupHandler(this.selected.ggs)
      // if (e === undefined || item === undefined) return

      // let ggsTempCopy = structuredClone(this.selected.ggs)
      // let tempGgs = []
      // this.levelsDictionary = {}
      // this.selected.ggs = []

      // if (e === true) {
      //   for (const level of this.selected.levels) {
      //     tempGgs.push(this.gradeGroupsDictionary[level.id].ggs)
      //   }
      // }else{
      //   tempGgs = tempGgs.concat(ggsTempCopy.filter((e)=> e.levelId !== item.id))
      // }
      
      // this.selected.ggs = tempGgs.flat()
    },
    selectAll(val){
      const selectAll = val
      const items = selectAll ? structuredClone(this.items) : [] 
      const ggs = selectAll ? items.map((e)=> e.ggs.map((e)=>e)).flat(2) : []

      this.selected.ggs = []
      this.levelHandler(items, ggs, selectAll)
      
      if (selectAll) {
        this.selected.levels = this.items
      }else{        
        this.selected.levels = []
      }
    },
    async _sleep(ms = 50){
      await new Promise((res) => {setTimeout(() => {res()}, ms);})
    },
    async _setInitialState(){
      this.selected.ggs = []
      this.selected.levels = [];
      this.levelsDictionary = {}
      this.gradeGroupsDictionary = {}
      this.checkAll = false

      await this._sleep()
      this.selected.ggs = this.selectedGG;
    },
    _isNull(value, fallback){
      if (value === undefined || value === null) {
        return fallback
      }
      return value
    },
    /**
     * @template T
     * @param {Array<T>} arr 
     * @param {(value:T, index: number, arr: Array<T>, {})=> {}} cb 
     */
    _groupBy(arr = [], cb){
      const temp = {}

      for (let i = 0; i < arr.length; i++) {
        const [tempGroupBy, value] = cb(arr[i], i, arr, temp);
        temp[tempGroupBy] = value;
      }

      return temp
    },
    _setLevelsAndGradeGroups(){
      this.gradeGroupHandler(this.selected.ggs).forEach(this._clickSimulation);
      if (this.selected.ggs.length === 0) {
        this.toast.remember = true;
      }
      // Object.keys(this.levelsDictionary).forEach(this._clickSimulation);

      // if (this.selected.ggs.length === 0) {
      //   return
      // }

      // for (const gg of this.selected.ggs) {
      //   if (this.levelsDictionary[gg.levelId] === undefined) {
      //     this.levelsDictionary[gg.levelId] = { levelId: gg.levelId, count: 1, isFullLevelSelected : this.gradeGroupsDictionary[gg.levelId].ggs.length === 1  }
      //     continue
      //   }
      
      //   this.levelsDictionary[gg.levelId].count =  this.levelsDictionary[gg.levelId].count + 1
      //   this.levelsDictionary[gg.levelId].isFullLevelSelected =  this.gradeGroupsDictionary[gg.levelId].ggs.length === this.levelsDictionary[gg.levelId].count

      //   if (this.levelsDictionary[gg.levelId].isFullLevelSelected) {
      //     this.selected.levels.push(this.gradeGroupsDictionary[gg.levelId])
      //   }
      // }

      // Object.keys(this.levelsDictionary).forEach(this._clickSimulation);
      
    },
    /**@param {String} id - Id of the dom element*/
    _clickSimulation(id){
      document.getElementById(id).click()
    },
    handleClick(info) {
      const isNull = (value, fallback) => {
        if (value === undefined || value === null) {
          return fallback
        }
        return value
      }
      // this.selected.ggs = info
      // this.start(this.selected.ggs);
      const selectedGgs = structuredClone(info).map((e)=>({ "id": e.id, "grade": e.grade, "group": e.group, "deleted": isNull(e.deleted, false), "levelId": e.levelId, "nStudents": isNull(e.nStudents, 0) }))
      this.selected.ggs = selectedGgs
      this.start();
    },
    start() {
      if (this.selected.ggs.length > 0) {
        this.wUpdate = true;
        this.$emit("init", this.selected.ggs);
        for (let i = 0; i < this.items.length; i += 1) {
          const item = this.items[i];
          this.$set(this.$refs.dTable.expanded, item.id, false);
        }
      } else {
        this.toast.alert = true;
      }
    },
    close() {
      this.$emit("input", !this.value);
      for (let i = 0; i < this.items.length; i += 1) {
        const item = this.items[i];
        this.$set(this.$refs.dTable.expanded, item.id, false);
      }
    },
    async getLevels() {
      this.working.loading = true;
      await this.$store
        .dispatch("level/getLevelsVisor")
        .then(response => {
          this.items = response.data.entity.levels;
          this.working.loading = false;
          // if (this.selected.ggs == "") {
          //   this.toast.remember = true;
          // }
        })
        .catch(error => {
          this.working.loading = false;
          console.log(error);
        });
    },
  },
};
</script>

<style>
.gruoup-selector-modal {
  color: red;
}
</style>
